module.exports = __webpack_public_path__ + "static/img/img_form_1_en.3c17f64d.png";